import { CheckCircleOutlined, CloseCircleOutlined, EditOutlined, ExclamationCircleOutlined, FileTextOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Tooltip } from "antd";
import PropTypes from 'prop-types';

export const ActionButtons = ({
    status,
    onEdit,
    onChangeType,
    onValidate,
    onRefuse,
    onClose,
    onResponsability,
    canEditType,
    validateLoading,
    refuseLoading,
    isClosed,
    tauxResponsabilite
}) => {
    const showValidate = status === 'A' || status === 'RF';
    const showRefuse = status === 'A';

    return (
        <Card bordered={false} style={{ marginTop: 16 }}>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={6}>
                    <Button
                        block
                        size="large"
                        icon={<EditOutlined />}
                        onClick={onEdit}
                        style={{ background: 'white', color: 'blue', borderColor: 'blue' }}
                    >
                        Modifier les informations
                    </Button>
                </Col>

                {canEditType && (
                    <Col xs={24} sm={12} lg={6}>
                        <Tooltip
                            title={status === 'O'
                                ? "Modifier le type génèrera un nouveau numéro"
                                : "Renseignez le type avant validation"
                            }
                        >
                            <Button
                                block
                                size="large"
                                icon={<FileTextOutlined />}
                                onClick={onChangeType}
                                style={{ background: 'white', color: 'green', borderColor: 'green' }}
                            >
                                Changer le type du sinistre
                            </Button>
                        </Tooltip>
                    </Col>
                )}

                {showValidate && (
                    <Col xs={24} sm={12} lg={6}>
                        <Button
                            block
                            size="large"
                            type="primary"
                            icon={<CheckCircleOutlined />}
                            loading={validateLoading}
                            disabled={refuseLoading}
                            onClick={onValidate}
                            style={{ background: 'white', color: '#52c41a', borderColor: '#52c41a' }}
                        >
                            Valider le dossier
                        </Button>
                    </Col>
                )}

                {showRefuse && (
                    <Col xs={24} sm={12} lg={6}>
                        <Button
                            block
                            size="large"
                            danger
                            icon={<CloseCircleOutlined />}
                            loading={refuseLoading}
                            disabled={validateLoading}
                            onClick={onRefuse}
                        >
                            Refuser le dossier
                        </Button>
                    </Col>
                )}

                <Col xs={24} sm={12} lg={6}>
                    <Button
                        block
                        size="large"
                        type="primary"
                        disabled={isClosed}
                        onClick={onResponsability}
                        style={{ background: 'white', color: '#242166', borderColor: '#242166' }}
                    >
                        {tauxResponsabilite
                            ? `Responsabilité: ${tauxResponsabilite}%`
                            : 'Définir responsabilité'
                        }
                    </Button>
                </Col>

                {showValidate ? null : <Col xs={24} sm={12} lg={6}>
                    <Button
                        block
                        size="large"
                        danger
                        icon={<ExclamationCircleOutlined />}
                        onClick={onClose}
                    >
                        {isClosed ? 'Réouvrir le dossier' : 'Clôturer le dossier'}
                    </Button>
                </Col>}
            </Row>
        </Card>
    );
};

ActionButtons.propTypes = {
    status: PropTypes.string.isRequired,
    onEdit: PropTypes.func.isRequired,
    onChangeType: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    onRefuse: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onResponsability: PropTypes.func.isRequired,
    canEditType: PropTypes.bool,
    validateLoading: PropTypes.bool,
    refuseLoading: PropTypes.bool,
    isClosed: PropTypes.bool,
    tauxResponsabilite: PropTypes.number
};
